import { useParams } from 'react-router-dom';

import { USER_TYPES } from 'shared_DEPRECATED/types/User';
import { routeNames } from 'shared_DEPRECATED/utils/config';

import { useUserMode } from 'features/user/hooks';

type SessionNavigationLinkProps = {
  coachingSessionId: string;
  email: string;
};

export const useSessionNavigationLink = ({
  coachingSessionId,
  email,
}: SessionNavigationLinkProps) => {
  const userMode = useUserMode();
  const { email: emailFromParams } = useParams();

  const participantEmail = email || emailFromParams;

  const userSpecificRoute =
    userMode === USER_TYPES.USER ? '' : `/hde/participants/${participantEmail}`;

  return `${userSpecificRoute}/${routeNames.SESSIONS}/${coachingSessionId}`;
};
